import {
  PreloadedQueryRef,
  useQueryRefHandlers,
  useReadQuery,
} from '@apollo/client';
import {
  StreamCardFragmentFragment,
  StreamSearchQueryQuery,
} from '@/__generated__/graphql.ts';
import { EmptyStreamsFeed } from '@/components/stream-list/empty-streams-feed.tsx';
import { StreamList } from '@/components/stream-list/stream-list.tsx';

export const StreamSearchResults = ({
  queryRef,
  skeletonItemCount,
}: {
  queryRef: PreloadedQueryRef<StreamSearchQueryQuery>;
  skeletonItemCount?: number;
}) => {
  const { fetchMore } = useQueryRefHandlers(queryRef);
  const {
    data: { search },
  } = useReadQuery(queryRef);
  return (
    <StreamList
      streams={search.items as StreamCardFragmentFragment[]}
      skeletonItemCount={skeletonItemCount}
      emptyState={<EmptyStreamsFeed afterSearch />}
      hasNext={!!search.offset}
      loadMore={() => {
        fetchMore({
          variables: { offset: search.offset },
        });
      }}
    />
  );
};
